export default "__VITE_ASSET__BjJAw_lL__"